<template>
  <span
    v-if="shouldDisplay"
    class="whitespace-nowrap text-right ordinal slashed-zero tabular-nums"
    :class="{ 'cursor-pointer': clickable }"
    v-html="
      yapAmount
        ? formatYapAmount(yapAmount, currency, {
            showPositiveSign,
            showNegativeSign,
            hidden: isHidden,
            ccyClasses,
            lineThrough
          })
        : formatAmount(
            localAmount,
            localCurrency,
            showPositiveSign,
            showNegativeSign,
            isHidden,
            ccyClasses,
            lineThrough
          )
    "
    @click="toggleHidden"
    data-testid="yapamount"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { YapAmount, YapMoney } from '@/types/general';
import { formatAmount, formatYapAmount } from '@/utils/locale';
import { factoredYapAmount } from '@/utils/general';
import { useProfileStore } from '@/store/profileStore';

const props = defineProps<{
  amount?: number | string;
  yapAmount?: YapAmount;
  yapMoney?: YapMoney;
  currency?: string;
  lineThrough?: boolean;
  showPositiveSign?: boolean;
  showNegativeSign?: boolean;
  clickable?: boolean;
  ccyClasses?: string;
}>();

const profileStore = useProfileStore();
const isHidden = computed(() => profileStore.isAmountVisible);

const shouldDisplay = computed(() => {
  return props.amount !== undefined || props.yapAmount !== undefined || props.yapMoney !== undefined;
});

const localAmount = computed(() => {
  if (props.yapAmount) {
    return factoredYapAmount(props.yapAmount);
  } else if (props.yapMoney) {
    return factoredYapAmount(props.yapMoney.amount);
  }
  return props.amount;
});

const localCurrency = computed(() => {
  if (props.yapMoney) {
    return props.yapMoney.currency;
  }
  return props.currency;
});

function toggleHidden() {
  if (props.clickable) {
    profileStore.setAmountVisible(!profileStore.isAmountVisible);
  }
}
</script>
